/* ----------------------------------
   Product Variants
---------------------------------- */
if (typeof ProductVariants !== "function") {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Grab product price elements if they exist
      this.price = document.querySelector(`#product-price-${this.dataset.id}`);
      if (this.price) {
        this.priceOriginal = this.price.querySelector("[data-js-product-price-original]");
        this.priceCompare  = this.price.querySelector("[data-js-product-price-compare]");
        this.priceUnit     = this.price.querySelector("[data-js-product-price-unit]");
      }

      // Grab the product form & related elements
      this.productForm = document.querySelector(`#product-form-${this.dataset.id}`);
      if (this.productForm) {
        this.productQty    = this.productForm.querySelector("[data-js-product-quantity]");
        this.addToCart     = this.productForm.querySelector("[data-js-product-add-to-cart]");
        this.addToCartText = this.productForm.querySelector("[data-js-product-add-to-cart-text]");
      }

      this.addEventListener("change", this.onVariantChange);
      let initVariantChange = false;

      if (this.hasAttribute("data-variant-required")) {
        this.variantRequired = true;
        this.noVariantSelectedYet = true;

        if (document.location.search.includes("variant")) {
          const initVariantID = parseInt(
            new URLSearchParams(document.location.search).get("variant")
          );
          this.currentVariant = this.getVariantData().find((variant) => {
            if (variant.id === initVariantID) {
              variant.options.forEach((option, idx) => {
                const container = this
                  .querySelectorAll("[data-js-product-variant]")[idx]
                  .querySelector("[data-js-product-variant-container]");
                if (container.dataset.jsProductVariantContainer === "radio") {
                  container.querySelector(`input[value="${option}"]`).checked = true;
                } else if (container.dataset.jsProductVariantContainer === "select") {
                  container.value = option;
                }
              });
              return variant;
            }
          });
          if (this.currentVariant) {
            this.variantRequired = false;
            this.noVariantSelectedYet = false;
            initVariantChange = true;
          }
        }
      } else {
        this.variantRequired = false;
        this.noVariantSelectedYet = false;
      }

      // Gather the selected options & find the current variant
      this.updateOptions();
      this.updateMasterId();
      this.updateUnavailableVariants();

      // If there's already a selected variant, set shipping date if available
      if (this.currentVariant) {
        const shippingDate = this.currentVariant.shipping_date;
        const shippingDateInput = document.querySelector('input[name="properties[_shipped_by]"]');
        if (shippingDateInput && shippingDate) {
          shippingDateInput.value = shippingDate;
        }
      }

      // Stock references
      this.productStock = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity]`);
      this.productStockProgress = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-progress]`);
      const dataEl = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`);
      if (this.productStock && dataEl) {
        this.productStockData = JSON.parse(dataEl.dataset.inventory);
      }

      this.updateStock();

      // Fire a custom event for variant changes
      this._event = new Event("VARIANT_CHANGE");
      if (initVariantChange) {
        this.onVariantChange();
      }

      // Track last "stock" state
      this.lastStockVariantState = this._getSelectedOption(0);
    }

    checkSoldOutOrComingSoon() {
      const productTags = document.querySelectorAll(".product-tags div");
      let isComingSoon = false;
      let isSoldOut = false;
    
      productTags.forEach((tag) => {
        const tagText = tag.textContent.trim().toLowerCase();
        if (tagText === "coming soon") isComingSoon = true;
        if (tagText === "sold out") isSoldOut = true;
      });
    
      if (isComingSoon) {
        return 'coming soon';
      }
  
      if (isSoldOut) {
        return 'sold out';
      }
    
    
      return false;
    }

    /* =====================
       Called on variant changes
    ===================== */
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantInput();

      //don't do anything if this is a full sold out or coming soon product
      const isSoldOutOrComingSoon = checkSoldOutOrComingSoon();
      console.log(isSoldOutOrComingSoon);
      if(isSoldOutOrComingSoon) {
        return;
      }

      //clear alert if it exists
      const existingAlert = document.getElementById("product-page-form-error-cart-alert");
      if (existingAlert) existingAlert.remove();

      if (this.price) {
        this.updatePrice();
      }
      this.updateStock();
      this.updateUnavailableVariants();
      this.updatePickupAvailability();
      if (!this.hasAttribute("data-no-history")) {
        this.updateURL();
      }
      this.updateDetails();

      if (this.productForm) {
        if (this.currentVariant) {
          const shippingDate = this.currentVariant.shipping_date;
          const shippingDateInput = document.querySelector('input[name="properties[_shipped_by]"]');
          if (shippingDateInput && shippingDate) {
            shippingDateInput.value = shippingDate;
          }
        }

        if (!this.currentVariant || !this.currentVariant.available) {
          if (this.productQty) this.productQty.style.display = "none";
          this.addToCart.classList.add("disabled");
          this.productForm.classList.add("disabled-cart");
          this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
        } else {
          console.log('form code running here');
          // if (this.productQty) this.productQty.style.display = "";
          // this.addToCart?.classList.remove("disabled");
          // this.productForm.classList.remove("disabled-cart");
          // if (this.addToCartText) {
          //   this.addToCartText.textContent = this.hasAttribute("data-show-bundle-wording")
          //     ? KROWN.settings.locales.products_add_to_bundle_button
          //     : this.addToCartText.hasAttribute("data-show-preorder-wording")
          //     ? KROWN.settings.locales.products_preorder_button
          //     : KROWN.settings.locales.products_add_to_cart_button;
          // }
        }

        if (!this.currentVariant) {
          this.productForm.classList.add("unavailable-variant");
          this.addToCartText.textContent =
            this.variantRequired && this.noVariantSelectedYet
              ? KROWN.settings.locales.products_variant_required
              : KROWN.settings.locales.products_unavailable_variant;
        } else {
          this.productForm.classList.remove("unavailable-variant");
        }
      }
      this.dispatchEvent(this._event);
    }

    /* =====================
       Gather the user’s current selected options
    ===================== */
    updateOptions() {
      this.options = [];
      this.querySelectorAll("[data-js-product-variant-container]").forEach((containerEl) => {
        if (containerEl.dataset.jsProductVariantContainer === "radio") {
          containerEl.querySelectorAll(".product-variant__input").forEach((inputEl) => {
            if (inputEl.checked) {
              this.options.push(inputEl.value);
            }
          });
        } else {
          // “select” or other
          if (!(this.variantRequired && containerEl.selectedIndex === 0)) {
            this.options.push(containerEl.value);
          }
        }
      });
      if (
        this.variantRequired &&
        this.noVariantSelectedYet &&
        this.options.length >= parseInt(this.dataset.variants, 10)
      ) {
        this.noVariantSelectedYet = false;
      }
    }

    /* =====================
       Finds the correct variant based on selected options
    ===================== */
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((opt, idx) => this.options[idx] === opt).includes(false);
      });

      // If there's a variant, handle in-stock vs pre-order container logic
      if (this.currentVariant) {
        const filterVariants = (nodeList, textOption) => {
          const matches = [];
          nodeList.forEach((node) => {
            const variantTxt = node.getAttribute("data-variant").toLowerCase();
            if (variantTxt.includes(textOption.toLowerCase())) {
              matches.push(node);
            }
          });
          return matches;
        };

        const updateFirstContainer = () => {
          const firstContainer = document.querySelector('[data-js-product-variant-container="radio"]');
          if (!firstContainer) return;
          firstContainer.querySelectorAll(".product-variant__item").forEach((item) => {
            const input = item.querySelector(".product-variant__input");
            if (input) {
              const variantTitle = input.value.split(" / ")[0];
              item.setAttribute("data-variant-title", variantTitle);
              item.removeAttribute("data-variant");
            }
          });
        };

        const selectSecondVariantContainer = () => {
          const containers = document.querySelectorAll(".product-variant__container");
          return containers.length > 1 ? containers[1] : null;
        };

        const updateVariantIds = (secondContainer, filteredResults) => {
          if (!secondContainer || !filteredResults.length) return;
          const children = secondContainer.children;
          Array.from(children).forEach((child) => {
            const label = child.querySelector("label");
            const input = child.querySelector("input");
            if (!label || !input) return;

            const sizeOption = label.textContent.trim().toLowerCase();
            filteredResults.forEach((res) => {
              const resVariant = res.getAttribute("data-variant").toLowerCase();
              const variantParts = resVariant.split("/");
              if (variantParts.length > 1) {
                const resSize = variantParts[1].trim().toLowerCase();
                if (resSize === sizeOption) {
                  child.setAttribute("data-variant", res.getAttribute("data-id"));
                  child.setAttribute("data-variant-title", res.getAttribute("data-variant"));
                }
              }
            });
          });
        };

        const choice = this.currentVariant.option1.toLowerCase();
        if (choice === "in-stock" || choice === "instock") {
          const allInfo = document.querySelectorAll(".limit_variant-main");
          const filtered = filterVariants(allInfo, this.currentVariant.option1);
          const secondContainer = selectSecondVariantContainer();
          updateFirstContainer();
          updateVariantIds(secondContainer, filtered);
        } else if (choice === "pre-order" || choice === "preorder") {
          const allInfo = document.querySelectorAll(".limit_variant-main");
          const filtered = filterVariants(allInfo, this.currentVariant.option1);
          const secondContainer = selectSecondVariantContainer();
          updateFirstContainer();
          updateVariantIds(secondContainer, filtered);
        }
      }
    }

    /* =====================
       Update hidden input field “id” with the chosen variant ID
    ===================== */
    updateVariantInput() {
      if (!this.currentVariant) return;
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`);
      productForms.forEach((form) => {
        const hiddenInput = form.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = this.currentVariant.id;
          hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
          // console.log('currentVariant', this.currentVariant);
          hiddenInput.title = this.currentVariant.title;
        }
      });
    }

    /* =====================
       Update Price Elements
    ===================== */
    updatePrice() {
      if (!this.currentVariant) {
        if (!(this.variantRequired && this.noVariantSelectedYet)) {
          if (this.priceOriginal) this.priceOriginal.innerHTML = "";
          if (this.priceCompare)  this.priceCompare.innerHTML  = "";
          if (this.priceUnit)     this.priceUnit.innerHTML     = "";
        }
        return;
      }
      if (this.priceOriginal) {
        this.priceOriginal.innerHTML = this._formatMoney(
          this.currentVariant.price,
          KROWN.settings.shop_money_format
        );
      }
      if (this.priceCompare) {
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          this.priceCompare.innerHTML = this._formatMoney(
            this.currentVariant.compare_at_price,
            KROWN.settings.shop_money_format
          );
        } else {
          this.priceCompare.innerHTML = "";
        }
      }
      if (this.priceUnit) {
        if (this.currentVariant.unit_price_measurement) {
          this.priceUnit.innerHTML = `
            ${this._formatMoney(
              this.currentVariant.unit_price,
              KROWN.settings.shop_money_format
            )} /
            ${
              this.currentVariant.unit_price_measurement.reference_value != 1
                ? this.currentVariant.unit_price_measurement.reference_value + " "
                : ""
            }
            ${this.currentVariant.unit_price_measurement.reference_unit}
          `;
        } else {
          this.priceUnit.innerHTML = "";
        }
      }
    }

    /* =====================
       Update Stock Indicators
    ===================== */
    updateStock() {
      if (!this.currentVariant) {
        if (this.productStock) {
          this.productStock.innerHTML = "";
        }
        return;
      }

      if (this.productStock && this.productStockData) {
        let currentData = this.productStockData.find((v) => v.id === this.currentVariant.id);
        this.productStock.innerHTML = "";

        if (currentData) {
          const qty = currentData.quantity;
          if (qty <= 0) {
            if (currentData.inventory === "continue") {
              this.productStock.innerHTML = KROWN.settings.locales.products_preorder;
              this.productStock.setAttribute("data-stock", "pre-order");
            } else if (currentData.inventory === "deny") {
              this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
              this.productStock.setAttribute("data-stock", "out-of-stock");
            }
          } else if (qty === 1) {
            this.productStock.innerHTML = KROWN.settings.locales.products_one_product;
            this.productStock.setAttribute("data-stock", "one-item-stock");
          } else if (qty <= parseInt(this.productStock.dataset.lowStock, 10)) {
            this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace("{{ count }}", qty);
            this.productStock.setAttribute("data-stock", "little-stock");
          } else if (currentData.unavailable) {
            this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
            this.productStock.setAttribute("data-stock", "out-of-stock");
          } else if (
            qty > parseInt(this.productStock.dataset.lowStock, 10) &&
            this.productStock.dataset.type === "always"
          ) {
            this.productStock.innerHTML = KROWN.settings.locales.products_many_products.replace("{{ count }}", qty);
            this.productStock.setAttribute("data-stock", "in-stock");
          } else if (!qty && this.productStock.dataset.type === "always") {
            this.productStock.innerHTML = KROWN.settings.locales.products_enough_products;
            this.productStock.setAttribute("data-stock", "in-stock");
          }

          if (this.productStockProgress) {
            let progressQty = 0;
            if ((qty <= 0 && currentData.inventory === "continue") || qty === undefined) {
              progressQty = parseInt(this.productStock.dataset.highStock, 10);
            } else if (qty > 0) {
              progressQty = qty;
            }
            if (progressQty >= parseInt(this.productStock.dataset.highStock, 10)) {
              this.productStockProgress.style.width = "100%";
            } else {
              const ratio = (100 * progressQty) / parseInt(this.productStock.dataset.highStock, 10);
              this.productStockProgress.style.width = `${ratio}%`;
            }
          }
        }
      }
    }

    /* =====================
       Update Additional Details (SKU, Barcode, etc.)
    ===================== */
    updateDetails() {
      // SKU
      document
        .querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`)
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.sku) {
            elm.innerHTML = KROWN.settings.locales.product_sku + this.currentVariant.sku;
          } else {
            elm.innerHTML = "";
          }
        });
      // Barcode
      document
        .querySelectorAll(`#product-${this.dataset.id} [data-js-product-barcode]`)
        .forEach((elm) => {
          if (this.currentVariant && this.currentVariant.barcode) {
            elm.innerHTML = KROWN.settings.locales.product_barcode + this.currentVariant.barcode;
          } else {
            elm.innerHTML = "";
          }
        });
    }

    /* =====================
       Update Pickup Availability
    ===================== */
    updatePickupAvailability() {
      const pickUpEl = document.querySelector("pickup-availability");
      if (!pickUpEl) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpEl.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpEl.removeAttribute("available");
        pickUpEl.innerHTML = "";
      }
    }

    /* =====================
       Hide/disable variants that are truly unavailable
    ===================== */
    updateUnavailableVariants() {
      if (this.dataset.hideVariants === "false") return;

      let options1 = {}, options2 = {}, options3 = {},
        option1Selected = null, option2Selected = null;

      // If the product has multiple variant "levels"
      if (this.dataset.variants > 1) {
        option1Selected = this._getSelectedOption(0);
        if (option1Selected !== this.lastStockVariantState) {
          this._resetDisabledOption(1);
          this.lastStockVariantState = option1Selected;
        }
      }
      if (this.dataset.variants > 2) {
        option2Selected = this._getSelectedOption(1);
        if (option2Selected !== this.lastStockVariantState) {
          this._resetDisabledOption(2);
          this.lastStockVariantState = option2Selected;
        }
      }

      // Map out availability for each variant in the data
      this.getVariantData().forEach((v) => {
        if (this.dataset.variants > 0) {
          if (!options1[v.option1]) options1[v.option1] = [];
          options1[v.option1].push(String(v.available));
        }
        if (this.dataset.variants > 1) {
          if (!options2[v.option2]) options2[v.option2] = [];
          options2[v.option2].push(String(v.available));
        }
        if (this.dataset.variants == 2 && v.option1 === option1Selected && !v.available) {
          this._setDisabledOption(1, v.option2);
        }
        if (this.dataset.variants > 2) {
          if (!options3[v.option3]) options3[v.option3] = [];
          options3[v.option3].push(String(v.available));
          if (v.option2 === option2Selected && v.option1 === option1Selected && !v.available) {
            this._setDisabledOption(2, v.option3);
          }
        }
      });

      // First-level variant
      if (this.dataset.variants > 0) {
        Object.keys(options1).forEach((key) => {
          if (!options1[key].includes("true")) {
            this._setDisabledOption(0, key);
          }
        });
      }
      // Second-level variant
      if (this.dataset.variants > 1) {
        Object.keys(options2).forEach((key) => {
          if (!options2[key].includes("true")) {
            this._setDisabledOption(1, key);
          }
        });
      }
      // Third-level variant
      if (this.dataset.variants > 2) {
        Object.keys(options3).forEach((key) => {
          if (!options3[key].includes("true")) {
            this._setDisabledOption(2, key);
          }
        });
        Object.keys(options2).forEach((key) => {
          if (!options2[key].includes("true") && option2Selected === key) {
            const thirdVariant = this.querySelectorAll("[data-js-product-variant]")[2]
              .querySelector(".product-variant-value");
            if (this.dataset.hideVariants === "disable") {
              thirdVariant.setAttribute("disabled", "disabled");
            } else {
              thirdVariant.classList.add("disabled");
            }
          }
        });
      }
    }

    /* =====================
       Returns the user’s selected option string for the i-th “level”
    ===================== */
    _getSelectedOption(i) {
      let selectedOption = null;
      const variantBlocks = this.querySelectorAll("[data-js-product-variant]")[i];
      variantBlocks
        .querySelectorAll("[data-js-product-variant-container]")
        .forEach((containerEl) => {
          if (containerEl.dataset.jsProductVariantContainer === "radio") {
            containerEl.querySelectorAll(".product-variant__input").forEach((radioEl) => {
              if (radioEl.checked) {
                selectedOption = radioEl.value;
              }
            });
          } else {
            selectedOption = containerEl.value;
          }
        });
      return selectedOption;
    }

    /* =====================
       Reset any disabled/hide classes on an option “level”
    ===================== */
    _resetDisabledOption(i) {
      const block = this.querySelectorAll("[data-js-product-variant]")[i];
      block.querySelectorAll(".product-variant-value").forEach((valEl) => {
        valEl.classList.remove("disabled", "hide-variant");
        if (!valEl.hasAttribute("default")) {
          valEl.removeAttribute("disabled");
        }
        valEl.parentNode.classList.remove("hide-variant");
      });
    }

    /* =====================
       Disable/hide a specific variant at level i
    ===================== */
    _setDisabledOption(i, option) {
      const variantContainer = this.querySelectorAll("[data-js-product-variant]")[i];
      const safeOption = option.replace('"', "&x22;");
      const variantEl = variantContainer.querySelector(`.product-variant-value[value="${safeOption}"]`);
      if (!variantEl) return;

      if (this.dataset.hideVariants === "disable") {
        variantEl.setAttribute("disabled", "disabled");
      } else if (this.dataset.hideVariants === "true") {
        variantEl.classList.add("disabled");
      } else if (this.dataset.hideVariants === "hide") {
        const contType = variantContainer
          .querySelector("[data-js-product-variant-container]").dataset.jsProductVariantContainer;
        if (contType === "radio") {
          variantEl.parentNode.classList.add("hide-variant");
        } else {
          variantEl.classList.add("hide-variant");
        }
      }
    }

    /* =====================
       Update the page URL with ?variant=xxx
    ===================== */
    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    /* =====================
       Retrieve the variant JSON from <script type="application/json">
    ===================== */
    getVariantData() {
      if (!this.variantData) {
        const jsonEl = this.querySelector('[type="application/json"]');
        this.variantData = JSON.parse(jsonEl.textContent);
      }
      return this.variantData;
    }

    /* =====================
       Money Formatting
    ===================== */
    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(num, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";
        if (isNaN(num) || num === null) return 0;

        num = (num / 100.0).toFixed(precision);
        const parts = num.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        const centsPart = parts[1] ? decimal + parts[1] : "";
        return dollars + centsPart;
      }

      const match = formatString.match(placeholderRegex);
      if (!match) return cents;

      switch (match[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("product-variants") === "undefined") {
    customElements.define("product-variants", ProductVariants);
  }
}

/* ----------------------------------
   Product Form
---------------------------------- */
if (typeof ProductForm !== "function") {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Detect cart type
      this.cartType = this.hasAttribute("data-ajax-cart") ? "ajax" : "page";
      const isCartPage = document.body.classList.contains("template-cart");
      if (!isCartPage || this.hasAttribute("data-force-form")) {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.ADD_TO_CART = new Event("add-to-cart");
      }

      // Mobile event hack for some themes
      if (document.body.classList.contains("touchevents")) {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.addEventListener("touchend", () => {
            // Could manually trigger .click() if needed
          });
        }
      }
    }

    async validatePreOrder(variantId, quantity) {
      try {
        // Get the quantity input value from the form
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        const requestedQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        
        // Get current cart data to check for existing items
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        let existingQuantity = 0;
        
        // Find the product ID for the variant
        const variantElement = document.querySelector(`.limit_variant-main[data-id="${variantId}"]`);
        const productId = variantElement ? Number(variantElement.getAttribute("data-productid")) : null;
        
        // Count how many of this item are already in the cart
        if (productId) {
          cartData.items.forEach((item) => {
            if (productId === item.product_id && parseInt(variantId) === item.id) {
              existingQuantity = item.quantity;
            }
          });
        }
        
        // Total quantity = what's already in cart + what's being added
        const totalQuantity = existingQuantity + requestedQuantity;
        console.log(`Validating pre-order: Variant ${variantId}, Requested ${requestedQuantity}, In Cart ${existingQuantity}, Total ${totalQuantity}`);
        
        const response = await fetch('https://ca96haabp7.execute-api.eu-west-3.amazonaws.com/prod/validate-preorder', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ variantId, quantity: totalQuantity }),
        });
      
        return await response.json();
      } catch (error) {
        console.error('Error validating pre-order:', error);
        // Return success in case of error to avoid blocking checkout
        return { success: true, message: 'Error checking pre-order availability' };
      }
    }

    async onSubmitHandler(e) {
      e.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      submitButton.classList.add("working");

      const needsPreorderCheck = this.form.dataset.needsPreorderCheck === 'true';
      const variantId = this.querySelector('input[name="id"]').value;
      const quantity = 1;

      console.log('needsPreorderCheck', needsPreorderCheck);
    
      try {
        if (needsPreorderCheck) {
          // Validate pre-order
          const validationResult = await this.validatePreOrder(variantId, quantity);
          if (!validationResult.success) {
            this.showAlert(validationResult.message, true);
            return;
          }          
        } else {
          // console.log('no pre-order check needed');
        }

        // console.log('can continue with sale, server check okay');
    
        // Proceed with adding to cart
        const body = this._serializeForm(this.form);
        let alertMessage = null;
    
        const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
          body,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
          method: "POST",
        });
    
        const responseData = await response.json();
        // console.log(responseData);
    
        if (responseData.status == 422) {
          // wrong stock logic alert
          alertMessage = typeof responseData.description === "string" ? responseData.description : responseData.message;
          this.showAlert(alertMessage, true);
          
          if (this.cartType == "page") {
            return;
          }
        } else if (this.cartType == "page") {
          document.location.href = KROWN.settings.routes.cart_url;
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:updatecache'));
    
        const cartResponse = await fetch("?section_id=helper-cart");
        const cartHtml = await cartResponse.text();
        this.updateCart(cartHtml, alertMessage);
    
        this.dispatchEvent(this.ADD_TO_CART);
    
        // a11y
        this.updateScreenReaderInfo();
    
      } catch (error) {
        console.error('Error:', error);
        this.showAlert("An error occurred while processing your request. Please try again.", true);
      } finally {
        submitButton.classList.remove("working");
        this.setupContinueShopping();
      }
    }
    
    showAlert(message, isError = false) {
      const alertElement = document.createElement("span");
      alertElement.className = isError ? "alert alert--error" : "alert";
      alertElement.innerHTML = message;
    
      const existingAlert = document.getElementById("product-page-form-error-cart-alert");
      if (existingAlert) existingAlert.remove();
    
      alertElement.style.marginTop = ".5rem";
      alertElement.style.marginBottom = "0";
      alertElement.id = "product-page-form-error-cart-alert";
      this.form.parentElement.append(alertElement);
    }
    
    updateCart(cartHtml, alertMessage = null) {
      const sectionInnerHTML = new DOMParser().parseFromString(cartHtml, "text/html");
      const cartFormInnerHTML = sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;
    
      // const cartItems = document.getElementById("AjaxCartForm");
      // cartItems.innerHTML = cartFormInnerHTML;
      // cartItems.ajaxifyCartItems();

      const amountOfItems = sectionInnerHTML.querySelector('span[data-cart-count]')?.textContent;
      const cartItems = document.getElementById("AjaxCartForm");
      
      if(amountOfItems != 0) {
        const cartItemsHeader = sectionInnerHTML.querySelector('.site-cart-heading')?.innerHTML;
        const cartItemsHolder = sectionInnerHTML.querySelector('.cart-holder')?.innerHTML;
        const cartItemsHolderDataItems = sectionInnerHTML.querySelector('.cart-holder')?.getAttribute('data-items');
        
        //update header
        if (cartItems.querySelector('.site-cart-heading')) {
          cartItems.querySelector('.site-cart-heading').innerHTML = cartItemsHeader;
        }
        
        cartItems.querySelector('.cart-holder').innerHTML = cartItemsHolder;
        cartItems.querySelector('.cart-holder').setAttribute('data-items', cartItemsHolderDataItems);
        cartItems.ajaxifyCartItems();
      } else {
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();
      }
    
      if (alertMessage) {
        this.showAlert(alertMessage, true);
      }
    
      document.getElementById("AjaxCartSubtotal").innerHTML = cartSubtotalInnerHTML;
    
      document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
        elm.textContent = document.querySelector("#AjaxCartForm [data-cart-count]").textContent;
      });
      document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
        elm.textContent = document.querySelector("#AjaxCartForm [data-cart-total]").textContent;
      });

      cleanProductTitles();
    }
    
    updateScreenReaderInfo() {
      const srInfo = document.getElementById("screen-reader-info");
      if (srInfo) {
        srInfo.innerText = KROWN.settings.locales.cart_announcement;
        setTimeout(() => {
          srInfo.innerText = "";
        }, 1000);
      }
    }
    
    setupContinueShopping() {
      const cartContinueShopping = document.getElementById("cart-continueshopping");
      if (cartContinueShopping) {
        cartContinueShopping.addEventListener("click", () => {
          const activeSidebarDrawer = document.querySelector("sidebar-drawer.active");
          if (activeSidebarDrawer && typeof activeSidebarDrawer.hide === "function") {
            activeSidebarDrawer.hide();
          }
        });
      }
    }


    _serializeForm(form) {
      let arr = [];
      Array.prototype.slice.call(form.elements).forEach((field) => {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;

        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach((opt) => {
            if (opt.selected) {
              arr.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(opt.value)}`);
            }
          });
          return;
        }
        if (["checkbox", "radio"].includes(field.type) && !field.checked) return;

        arr.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
      });
      return arr.join("&");
    }
  }

  if (typeof customElements.get("product-form") === "undefined") {
    customElements.define("product-form", ProductForm);
  }
}

/* ----------------------------------
   Product Recommendations
---------------------------------- */
if (typeof ProductRecommendations !== "function") {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const SUCCESS = new Event("product-recommendations-loaded");
      const FAIL    = new Event("product-recommendations-error");

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((res) => res.text())
          .then((text) => {
            const doc       = new DOMParser().parseFromString(text, "text/html");
            const innerHTML = doc.querySelector("product-recommendations");
            if (innerHTML && innerHTML.querySelectorAll("[data-js-product-item]").length > 0) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll("form").forEach((formEl) => {
                if (formEl.querySelector("template")) {
                  formEl.append(formEl.querySelector("template").content.cloneNode(true));
                }
              });
              this.dispatchEvent(SUCCESS);
            } else {
              this.dispatchEvent(FAIL);
            }
          })
          .catch(() => {
            this.dispatchEvent(FAIL);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: `0px 0px 400px 0px`,
      }).observe(this);
    }
  }

  if (typeof customElements.get("product-recommendations") === "undefined") {
    customElements.define("product-recommendations", ProductRecommendations);
  }
}

/* ----------------------------------
   Gift Card Recipient
---------------------------------- */
if (typeof GiftCardRecipient !== "function") {
  class GiftCardRecipient extends HTMLElement {
    constructor() {
      super();
      const properties = [...this.querySelectorAll('[name*="properties"]')];
      const checkboxPropertyName = "properties[__shopify_send_gift_card_to_recipient]";

      this.recipientCheckbox = properties.find((inp) => inp.name === checkboxPropertyName);
      this.recipientOtherProperties = properties.filter((inp) => inp.name !== checkboxPropertyName);
      this.recipientFieldsContainer = this.querySelector(".gift-card-recipient__fields");

      if (this.recipientCheckbox) {
        this.recipientCheckbox.addEventListener("change", this.synchronizeProperties.bind(this));
      }
      this.synchronizeProperties();
    }

    synchronizeProperties() {
      this.recipientOtherProperties.forEach(
        (prop) => (prop.disabled = !this.recipientCheckbox.checked)
      );
      this.recipientFieldsContainer.classList.toggle("hide", !this.recipientCheckbox.checked);
    }
  }

  if (typeof customElements.get("gift-card-recipient") === "undefined") {
    customElements.define("gift-card-recipient", GiftCardRecipient);
  }
}